import { dreamService } from "motw_core/Services/DreamService";
import * as React from "react";
import { activeDreamFilterStyle } from "source/app/presentation/MainPanel/Dreams/DreamFilterButtons/Filters/Helpers/ActiveDreamFilterClass";
import { clearedDreamFilters } from "source/app/presentation/MainPanel/Dreams/DreamFilterButtons/Helpers/clearedDreamFilters";
import Dreams from "source/app/presentation/MainPanel/Dreams/Dreams";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import { AreDreamsFiltered } from "../../Helpers/AreDreamsFiltered";
import { IDreamsState } from "../../IDreamsState";
import { NavigateToDreamsRoute } from "../../Routing/DreamsRouting";
import IDream from "motw_core/Entity/IDream";
import { EDragDropObject } from "source/app/services/Shared/EDragDropObject";
import { useDropTarget } from "source/app/services/Shared/Hooks/useDropTarget";
import { HandleTodayDropAsync } from "../../HashTags/Link/HandleHashTagLinkDropAsync";

export function ShowToday({ dreams }: { dreams: Dreams }) {
    const dropTargetResult = useDropTarget<IDream>(
        [EDragDropObject.dreamRow],
        HandleTodayDropAsync
    );
    const todayDreams = dreams.state.dreamsdata.filter(
        dreamService.IsTodaysDream
    );

    const dreamCount = dreams ? todayDreams.length : 0;

    const textToDisplay = `Today (${dreamCount})`;

    return (
        <span
            ref={dropTargetResult.dropTargetRef}
            style={{
                color: `yellowgreen`,
                fontWeight: dropTargetResult.isOver ? "bold" : "initial",
            }}
            {...ActiveDreamFilterClass(dreams)}
        >
            <IconWithText
                iconSuffix={EGlyphicon.king}
                whenClicked={() => LoadDreamsToday()}
                displayAsBlock={false}
            >
                {textToDisplay}
            </IconWithText>
        </span>
    );
}

export function LoadDreamsToday() {
    const dreams = State.ReadClass<IDreamsState>(ESharedComponent.Dreams);

    if (dreams) {
        NavigateToDreamsRoute(`Today`);
        dreams.setState(todayOnlyFilters);
    }
}

const todayOnlyFilters: Partial<IDreamsState> = {
    ...clearedDreamFilters,
    onlyShowTodaysDreams: true,
};

function ActiveDreamFilterClass(dreams: Dreams) {
    const isFilterActive =
        AreDreamsFiltered(dreams.state) && dreams.state.onlyShowTodaysDreams;

    const className = isFilterActive ? activeDreamFilterStyle : ``;
    return { className };
}
